module.exports = __webpack_public_path__ + "img/card-icon-action.27acb530.svg";